import {IssueClosedIcon, IssueOpenedIcon} from '@primer/octicons-react'

import {categoryStatusVisual, type IssueStatusColor, type IssueStatusVisual} from './issue-status-visuals'
import styles from './IssueStatusIcon.module.css'

export type IssueStatusIconStatus = {
  // Optional because list payloads served before the category was added don't carry it.
  category: {key?: string | null; state: 'OPEN' | 'CLOSED'}
}

const ICON_CLASSES: Record<IssueStatusColor, string> = {
  open: styles.open,
  done: styles.done,
  muted: styles.muted,
}

export function issueStatusVisual(status: IssueStatusIconStatus): IssueStatusVisual {
  return (
    categoryStatusVisual(status.category.key) ??
    (status.category.state === 'OPEN' ? {icon: IssueOpenedIcon, color: 'open'} : {icon: IssueClosedIcon, color: 'done'})
  )
}

export function IssueStatusIcon({
  status,
  'aria-label': ariaLabel,
}: {
  status: IssueStatusIconStatus
  'aria-label'?: string
}) {
  const {icon: StatusIcon, color} = issueStatusVisual(status)
  return <StatusIcon className={ICON_CLASSES[color]} aria-label={ariaLabel} />
}
